import React, { useState, useEffect, useMemo } from "react";
import axios from 'axios';
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheck, FaSearch, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Form } from "react-bootstrap";
import "./JobSeekerRegistration.css";
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';
import AgencyNavbar from "../../Pages/Navbar/AgencyNavbar";

// Enhanced country codes with all countries
const countryCodes = [
  // Job Seeker Source Countries
  { code: "+91", name: "India", category: "jobSeeker", nationality: true },
  { code: "+880", name: "Bangladesh", category: "jobSeeker", nationality: true },
  { code: "+977", name: "Nepal", category: "jobSeeker", nationality: true },
  { code: "+94", name: "Sri Lanka", category: "jobSeeker", nationality: true },
  { code: "+92", name: "Pakistan", category: "jobSeeker", nationality: true },
  { code: "+63", name: "Philippines", category: "jobSeeker", nationality: true },
  { code: "+62", name: "Indonesia", category: "jobSeeker", nationality: true },
  { code: "+95", name: "Myanmar", category: "jobSeeker", nationality: true },
  { code: "+84", name: "Vietnam", category: "jobSeeker", nationality: true },
  { code: "+855", name: "Cambodia", category: "jobSeeker", nationality: true },
  { code: "+66", name: "Thailand", category: "jobSeeker", nationality: true },
  { code: "+251", name: "Ethiopia", category: "jobSeeker", nationality: true },
  { code: "+254", name: "Kenya", category: "jobSeeker", nationality: true },
  { code: "+256", name: "Uganda", category: "jobSeeker", nationality: true },
  { code: "+255", name: "Tanzania", category: "jobSeeker", nationality: true },
  { code: "+250", name: "Rwanda", category: "jobSeeker", nationality: true },
  { code: "+233", name: "Ghana", category: "jobSeeker", nationality: true },
  { code: "+234", name: "Nigeria", category: "jobSeeker", nationality: true },
  { code: "+232", name: "Sierra Leone", category: "jobSeeker", nationality: true },
  { code: "+257", name: "Burundi", category: "jobSeeker", nationality: true },
  { code: "+237", name: "Cameroon ", category: "jobSeeker", nationality: true },

  // Employer/Hiring Countries
  { code: "+971", name: "UAE", category: "employer", nationality: true },
  { code: "+971", name: "Dubai", category: "employer", nationality: true },
  { code: "+966", name: "Saudi Arabia", category: "employer", nationality: true },
  { code: "+974", name: "Qatar", category: "employer", nationality: true },
  { code: "+965", name: "Kuwait", category: "employer", nationality: true },
  { code: "+973", name: "Bahrain", category: "employer", nationality: true },
  { code: "+968", name: "Oman", category: "employer", nationality: true },
  { code: "+65", name: "Singapore", category: "employer", nationality: true },
  { code: "+60", name: "Malaysia", category: "employer", nationality: true },
  { code: "+852", name: "Hong Kong", category: "employer", nationality: true },
  { code: "+81", name: "Japan", category: "employer", nationality: true },
  { code: "+82", name: "South Korea", category: "employer", nationality: true },
  { code: "+886", name: "Taiwan", category: "employer", nationality: true },
  { code: "+49", name: "Germany", category: "employer", nationality: true },
  { code: "+31", name: "Netherlands", category: "employer", nationality: true },
  { code: "+44", name: "United Kingdom", category: "employer", nationality: true },
  { code: "+39", name: "Italy", category: "employer", nationality: true },
  { code: "+34", name: "Spain", category: "employer", nationality: true },
  { code: "+33", name: "France", category: "employer", nationality: true },
  { code: "+48", name: "Poland", category: "employer", nationality: true },
  { code: "+351", name: "Portugal", category: "employer", nationality: true },
  { code: "+40", name: "Romania", category: "employer", nationality: true },
  { code: "+36", name: "Hungary", category: "employer", nationality: true },
  { code: "+1", name: "Canada", category: "employer", nationality: true },
  { code: "+1", name: "United States", category: "employer", nationality: true },
  { code: "+61", name: "Australia", category: "employer", nationality: true },
  { code: "+64", name: "New Zealand", category: "employer", nationality: true },
  { code: "+90", name: "Turkey", category: "employer", nationality: true },
  { code: "+93", name: "Afghanistan", category: "agency", nationality: true },
  { code: "+355", name: "Albania", category: "agency", nationality: true },
  { code: "+213", name: "Algeria", category: "agency", nationality: true },
  { code: "+376", name: "Andorra", category: "agency", nationality: true },
  { code: "+244", name: "Angola", category: "agency", nationality: true },
  { code: "+54", name: "Argentina", category: "agency", nationality: true },
  { code: "+374", name: "Armenia", category: "agency", nationality: true },
  { code: "+43", name: "Austria", category: "agency", nationality: true },
  { code: "+994", name: "Azerbaijan", category: "agency", nationality: true },
  { code: "+973", name: "Bahrain", category: "agency", nationality: true },
  { code: "+375", name: "Belarus", category: "agency", nationality: true },
  { code: "+32", name: "Belgium", category: "agency", nationality: true },
  { code: "+501", name: "Belize", category: "agency", nationality: true },
  { code: "+229", name: "Benin", category: "agency", nationality: true },
  { code: "+975", name: "Bhutan", category: "agency", nationality: true },
  { code: "+591", name: "Bolivia", category: "agency", nationality: true },
  { code: "+387", name: "Bosnia and Herzegovina", category: "agency", nationality: true },
  { code: "+267", name: "Botswana", category: "agency", nationality: true },
  { code: "+55", name: "Brazil", category: "agency", nationality: true },
  { code: "+673", name: "Brunei", category: "agency", nationality: true },
  { code: "+359", name: "Bulgaria", category: "agency", nationality: true },
  { code: "+226", name: "Burkina Faso", category: "agency", nationality: true },
  { code: "+257", name: "Burundi", category: "agency", nationality: true },
  { code: "+238", name: "Cabo Verde", category: "agency", nationality: true },
  { code: "+237", name: "Cameroon", category: "agency", nationality: true },
  { code: "+236", name: "Central African Republic", category: "agency", nationality: true },
  { code: "+235", name: "Chad", category: "agency", nationality: true },
  { code: "+56", name: "Chile", category: "agency", nationality: true },
  { code: "+86", name: "China", category: "agency", nationality: true },
  { code: "+57", name: "Colombia", category: "agency", nationality: true },
  { code: "+269", name: "Comoros", category: "agency", nationality: true },
  { code: "+242", name: "Congo", category: "agency", nationality: true },
  { code: "+506", name: "Costa Rica", category: "agency", nationality: true },
  { code: "+385", name: "Croatia", category: "agency", nationality: true },
  { code: "+53", name: "Cuba", category: "agency", nationality: true },
  { code: "+357", name: "Cyprus", category: "agency", nationality: true },
  { code: "+420", name: "Czech Republic", category: "agency", nationality: true },
  { code: "+243", name: "Democratic Republic of the Congo", category: "agency", nationality: true },
  { code: "+45", name: "Denmark", category: "agency", nationality: true },
  { code: "+253", name: "Djibouti", category: "agency", nationality: true },
  { code: "+1-767", name: "Dominica", category: "agency", nationality: true },
  { code: "+1-809", name: "Dominican Republic", category: "agency", nationality: true },
  { code: "+670", name: "East Timor", category: "agency", nationality: true },
  { code: "+593", name: "Ecuador", category: "agency", nationality: true },
  { code: "+20", name: "Egypt", category: "agency", nationality: true },
  { code: "+503", name: "El Salvador", category: "agency", nationality: true },
  { code: "+240", name: "Equatorial Guinea", category: "agency", nationality: true },
  { code: "+291", name: "Eritrea", category: "agency", nationality: true },
  { code: "+372", name: "Estonia", category: "agency", nationality: true },
  { code: "+268", name: "Eswatini", category: "agency", nationality: true },
  { code: "+251", name: "Ethiopia", category: "agency", nationality: true },
  { code: "+679", name: "Fiji", category: "agency", nationality: true },
  { code: "+358", name: "Finland", category: "agency", nationality: true },
  { code: "+241", name: "Gabon", category: "agency", nationality: true },
  { code: "+220", name: "Gambia", category: "agency", nationality: true },
  { code: "+995", name: "Georgia", category: "agency", nationality: true },
  { code: "+233", name: "Ghana", category: "agency", nationality: true },
  { code: "+30", name: "Greece", category: "agency", nationality: true },
  { code: "+1-473", name: "Grenada", category: "agency", nationality: true },
  { code: "+502", name: "Guatemala", category: "agency", nationality: true },
  { code: "+224", name: "Guinea", category: "agency", nationality: true },
  { code: "+245", name: "Guinea-Bissau", category: "agency", nationality: true },
  { code: "+592", name: "Guyana", category: "agency", nationality: true },
  { code: "+509", name: "Haiti", category: "agency", nationality: true },
  { code: "+504", name: "Honduras", category: "agency", nationality: true },
  { code: "+36", name: "Hungary", category: "agency", nationality: true },
  { code: "+354", name: "Iceland", category: "agency", nationality: true },
  { code: "+91", name: "India", category: "agency", nationality: true },
  { code: "+62", name: "Indonesia", category: "agency", nationality: true },
  { code: "+98", name: "Iran", category: "agency", nationality: true },
  { code: "+964", name: "Iraq", category: "agency", nationality: true },
  { code: "+353", name: "Ireland", category: "agency", nationality: true },
  { code: "+972", name: "Israel", category: "agency", nationality: true },
  { code: "+39", name: "Italy", category: "agency", nationality: true },
  { code: "+225", name: "Ivory Coast", category: "agency", nationality: true },
  { code: "+1-876", name: "Jamaica", category: "agency", nationality: true },
  { code: "+962", name: "Jordan", category: "agency", nationality: true },
  { code: "+7", name: "Kazakhstan", category: "agency", nationality: true },
  { code: "+254", name: "Kenya", category: "agency", nationality: true },
  { code: "+686", name: "Kiribati", category: "agency", nationality: true },
  { code: "+965", name: "Kuwait", category: "agency", nationality: true },
  { code: "+996", name: "Kyrgyzstan", category: "agency", nationality: true },
  { code: "+856", name: "Laos", category: "agency", nationality: true },
  { code: "+371", name: "Latvia", category: "agency", nationality: true },
  { code: "+961", name: "Lebanon", category: "agency", nationality: true },
  { code: "+266", name: "Lesotho", category: "agency", nationality: true },
  { code: "+231", name: "Liberia", category: "agency", nationality: true },
  { code: "+218", name: "Libya", category: "agency", nationality: true },
  { code: "+423", name: "Liechtenstein", category: "agency", nationality: true },
  { code: "+370", name: "Lithuania", category: "agency", nationality: true },
  { code: "+352", name: "Luxembourg", category: "agency", nationality: true },
  { code: "+261", name: "Madagascar", category: "agency", nationality: true },
  { code: "+265", name: "Malawi", category: "agency", nationality: true },
  { code: "+60", name: "Malaysia", category: "agency", nationality: true },
  { code: "+960", name: "Maldives", category: "agency", nationality: true },
  { code: "+223", name: "Mali", category: "agency", nationality: true },
  { code: "+356", name: "Malta", category: "agency", nationality: true },
  { code: "+692", name: "Marshall Islands", category: "agency", nationality: true },
  { code: "+222", name: "Mauritania", category: "agency", nationality: true },
  { code: "+230", name: "Mauritius", category: "agency", nationality: true },
  { code: "+52", name: "Mexico", category: "agency", nationality: true },
  { code: "+691", name: "Micronesia", category: "agency", nationality: true },
  { code: "+373", name: "Moldova", category: "agency", nationality: true },
  { code: "+377", name: "Monaco", category: "agency", nationality: true },
  { code: "+976", name: "Mongolia", category: "agency", nationality: true },
  { code: "+382", name: "Montenegro", category: "agency", nationality: true },
  { code: "+212", name: "Morocco", category: "agency", nationality: true },
  { code: "+258", name: "Mozambique", category: "agency", nationality: true },
  { code: "+95", name: "Myanmar", category: "agency", nationality: true },
  { code: "+264", name: "Namibia", category: "agency", nationality: true },
  { code: "+674", name: "Nauru", category: "agency", nationality: true },
  { code: "+977", name: "Nepal", category: "agency", nationality: true },
  { code: "+31", name: "Netherlands", category: "agency", nationality: true },
  { code: "+505", name: "Nicaragua", category: "agency", nationality: true },
  { code: "+227", name: "Niger", category: "agency", nationality: true },
  { code: "+234", name: "Nigeria", category: "agency", nationality: true },
  { code: "+850", name: "North Korea", category: "agency", nationality: true },
  { code: "+389", name: "North Macedonia", category: "agency", nationality: true },
  { code: "+47", name: "Norway", category: "agency", nationality: true },
  { code: "+968", name: "Oman", category: "agency", nationality: true },
  { code: "+92", name: "Pakistan", category: "agency", nationality: true },
  { code: "+680", name: "Palau", category: "agency", nationality: true },
  { code: "+970", name: "Palestine", category: "agency", nationality: true },
  { code: "+507", name: "Panama", category: "agency", nationality: true },
  { code: "+675", name: "Papua New Guinea", category: "agency", nationality: true },
  { code: "+595", name: "Paraguay", category: "agency", nationality: true },
  { code: "+51", name: "Peru", category: "agency", nationality: true },
  { code: "+63", name: "Philippines", category: "agency", nationality: true },
  { code: "+48", name: "Poland", category: "agency", nationality: true },
  { code: "+351", name: "Portugal", category: "agency", nationality: true },
  { code: "+974", name: "Qatar", category: "agency", nationality: true },
  { code: "+40", name: "Romania", category: "agency", nationality: true },
  { code: "+7", name: "Russia", category: "agency", nationality: true },
  { code: "+250", name: "Rwanda", category: "agency", nationality: true },
  { code: "+1-869", name: "Saint Kitts and Nevis", category: "agency", nationality: true },
  { code: "+1-758", name: "Saint Lucia", category: "agency", nationality: true },
  { code: "+1-784", name: "Saint Vincent and the Grenadines", category: "agency", nationality: true },
  { code: "+685", name: "Samoa", category: "agency", nationality: true },
  { code: "+378", name: "San Marino", category: "agency", nationality: true },
  { code: "+239", name: "Sao Tome and Principe", category: "agency", nationality: true },
  { code: "+966", name: "Saudi Arabia", category: "agency", nationality: true },
  { code: "+221", name: "Senegal", category: "agency", nationality: true },
  { code: "+381", name: "Serbia", category: "agency", nationality: true },
  { code: "+248", name: "Seychelles", category: "agency", nationality: true },
  { code: "+232", name: "Sierra Leone", category: "agency", nationality: true },
  { code: "+65", name: "Singapore", category: "agency", nationality: true },
  { code: "+421", name: "Slovakia", category: "agency", nationality: true },
  { code: "+386", name: "Slovenia", category: "agency", nationality: true },
  { code: "+677", name: "Solomon Islands", category: "agency", nationality: true },
  { code: "+252", name: "Somalia", category: "agency", nationality: true },
  { code: "+27", name: "South Africa", category: "agency", nationality: true },
  { code: "+82", name: "South Korea", category: "agency", nationality: true },
  { code: "+211", name: "South Sudan", category: "agency", nationality: true },
  { code: "+34", name: "Spain", category: "agency", nationality: true },
  { code: "+94", name: "Sri Lanka", category: "agency", nationality: true },
  { code: "+249", name: "Sudan", category: "agency", nationality: true },
  { code: "+597", name: "Suriname", category: "agency", nationality: true },
  { code: "+46", name: "Sweden", category: "agency", nationality: true },
  { code: "+41", name: "Switzerland", category: "agency", nationality: true },
  { code: "+963", name: "Syria", category: "agency", nationality: true },
  { code: "+886", name: "Taiwan", category: "agency", nationality: true },
  { code: "+992", name: "Tajikistan", category: "agency", nationality: true },
  { code: "+255", name: "Tanzania", category: "agency", nationality: true },
  { code: "+66", name: "Thailand", category: "agency", nationality: true },
  { code: "+228", name: "Togo", category: "agency", nationality: true },
  { code: "+676", name: "Tonga", category: "agency", nationality: true },
  { code: "+1-868", name: "Trinidad and Tobago", category: "agency", nationality: true },
  { code: "+216", name: "Tunisia", category: "agency", nationality: true },
  { code: "+90", name: "Turkey", category: "agency", nationality: true },
  { code: "+993", name: "Turkmenistan", category: "agency", nationality: true },
  { code: "+688", name: "Tuvalu", category: "agency", nationality: true },
  { code: "+256", name: "Uganda", category: "agency", nationality: true },
  { code: "+380", name: "Ukraine", category: "agency", nationality: true },
  { code: "+971", name: "United Arab Emirates", category: "agency", nationality: true },
  { code: "+44", name: "United Kingdom", category: "agency", nationality: true },
  { code: "+598", name: "Uruguay", category: "agency", nationality: true },
  { code: "+998", name: "Uzbekistan", category: "agency", nationality: true },
  { code: "+678", name: "Vanuatu", category: "agency", nationality: true },
  { code: "+379", name: "Vatican City", category: "agency", nationality: true },
  { code: "+58", name: "Venezuela", category: "agency", nationality: true },
  { code: "+84", name: "Vietnam", category: "agency", nationality: true },
  { code: "+967", name: "Yemen", category: "agency", nationality: true },
  { code: "+260", name: "Zambia", category: "agency", nationality: true },
  { code: "+263", name: "Zimbabwe", category: "agency", nationality: true }
];

// Function to validate phone number input
const validatePhoneNumber = (value) => {
  return value.replace(/\D/g, '');
};

// Phone Input Component with Country Code
const PhoneInputWithCountryCode = React.memo(({
  numberField,
  countryCodeField,
  placeholder,
  required = false,
  className = "form-control rounded-input",
  formData,
  onCountryCodeChange,
  onInputChange,
  userType = "jobSeeker"
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const normalizeText = (value) =>
    (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();

  const uniqueCountries = useMemo(() => {
    const seen = new Set();
    return countryCodes.filter((country) => {
      const dedupeKey = `${country.code}|${country.name}`;
      if (seen.has(dedupeKey)) return false;
      seen.add(dedupeKey);
      return true;
    });
  }, []);

  const filteredCountries = useMemo(() => {
    const query = normalizeText(searchTerm);
    if (!query) return uniqueCountries;
    return uniqueCountries.filter((country) => {
      const name = normalizeText(country.name);
      const code = normalizeText(country.code);
      return name.includes(query) || code.includes(query);
    });
  }, [searchTerm, uniqueCountries]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getDisplayValue = (code) => {
    const country = uniqueCountries.find(c => c.code === code);
    return country ? `${code} (${country.name})` : "Select Code";
  };

  return (
    <div className="row g-2 align-items-center mb-3">
      <div className="col-5">
        <Dropdown show={isOpen} onToggle={setIsOpen} autoClose="outside">
          <Dropdown.Toggle
            variant="light"
            className="w-100 d-flex justify-content-between align-items-center"
            style={{
              border: '1px solid #ced4da',
              borderRadius: '0.375rem',
              backgroundColor: '#fff',
              padding: '0.375rem 0.75rem',
              fontSize: '0.875rem',
              minHeight: '38px',
              textAlign: 'left'
            }}
          >
            <span className="text-truncate">
              {getDisplayValue(formData[countryCodeField])}
            </span>
            <FaChevronDown className="ms-2" size={12} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="w-100 p-2"
            style={{ maxWidth: '300px', maxHeight: '250px', overflowY: 'auto', overflowX: 'hidden' }}
          >
            <div
              className="px-2 mb-2 position-relative"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <FaSearch
                className="position-absolute"
                style={{ top: '10px', left: '15px', color: '#6c757d' }}
                size={12}
              />
              <Form.Control
                type="text"
                placeholder="Search country/code..."
                value={searchTerm}
                onChange={handleSearchChange}
                className="ps-4 py-1"
                style={{ fontSize: '0.875rem' }}
                size="sm"
                autoComplete="off"
                autoFocus
              />
            </div>

            <div>
              {filteredCountries.map((country, index) => (
                <Dropdown.Item
                  key={`${country.code}-${country.name}-${index}`}
                  onClick={() => {
                    onCountryCodeChange(countryCodeField, country.code);
                    setSearchTerm("");
                    setIsOpen(false);
                  }}
                  className="d-flex justify-content-between align-items-center py-1"
                  style={{ fontSize: '0.875rem' }}
                >
                  <span className="text-truncate">{country.name}</span>
                  <span className="text-muted ms-2">{country.code}</span>
                </Dropdown.Item>
              ))}
              {filteredCountries.length === 0 && (
                <div className="text-muted px-3 py-2" style={{ fontSize: '0.875rem' }}>
                  No country found
                </div>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <div className="col-7">
        <input
          type="tel"
          name={numberField}
          className={className}
          placeholder={placeholder}
          value={formData[numberField] || ""}
          onChange={onInputChange}
          required={required}
          pattern="[0-9]*"
          inputMode="numeric"
          onKeyPress={(e) => {
            if (!/[0-9]/.test(e.key) &&
              e.key !== 'Backspace' &&
              e.key !== 'Delete' &&
              e.key !== 'Tab' &&
              e.key !== 'ArrowLeft' &&
              e.key !== 'ArrowRight' &&
              e.key !== 'Home' &&
              e.key !== 'End') {
              e.preventDefault();
            }
          }}
          style={{ height: '38px' }}
        />
      </div>
    </div>
  );
});

const JobSeekerRegistration = ({ onSuccess }) => {
  const [userType] = useState("jobSeeker");
  const navigate = useNavigate();
  const location = useLocation();
  const [agencyUserId, setAgencyUserId] = useState(null);
  const [agencyUserEmail, setAgencyUserEmail] = useState(null);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    mobile_number_country_code: "+91",
    whatsapp_number: "",
    whatsapp_country_code: "+91",
  });
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");

  useEffect(() => {
    if (location.state && location.state.agencyUserEmail) {
      console.log('Received agency user email:', location.state.agencyUserEmail);
      setAgencyUserEmail(location.state.agencyUserEmail);
    }
  }, [location.state]);

  useEffect(() => {
    // Get agency user ID from navigation state
    if (location.state && location.state.agencyUserId) {
      console.log('Received agency user ID:', location.state.agencyUserId);
      setAgencyUserId(location.state.agencyUserId);
    } else {
      console.warn('No agency user ID received in navigation state');
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let processedValue = value;

    // Apply validation for phone number fields
    if (name === "mobile_number" || name === "whatsapp_number") {
      processedValue = validatePhoneNumber(value);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: processedValue,
    }));

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value.trim())) {
        setEmailError("Please enter a valid email address");
      } else {
        setEmailError("");
      }
    }
  };

  const handleCountryCodeChange = (fieldName, countryCode) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: countryCode
    }));
  };

  // Function to create job seeker record in job_seekers table
  // IMPORTANT: userId parameter is the AUTO-INCREMENTED ID from users table
  const createJobSeekerRecord = async (userId) => {
    try {
      // userId is the ID that was generated when inserting into users table
      // This is the AUTO-INCREMENTED ID from the database
      const jobSeekerPayload = {
        user_id: userId, // This is the ID from users table (auto-incremented)
        agency_uid: agencyUserId,
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim() || formData.first_name.trim(),
        email_id: formData.email.trim() || null,
        agency_mail: agencyUserEmail || "",
        whatsapp_country_code: formData.whatsapp_country_code,
        whatsapp_number: formData.whatsapp_number || null,
        source: "agency", // Add this line to set source as "agency" instead of "Direct"
      };

      console.log('Creating job seeker record with user_id from users table:', userId);
      console.log('Job Seeker Payload:', jobSeekerPayload);
      console.log('Job Seeker API URL:', `${BaseUrl}/api/job-seeker`);

      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(jobSeekerPayload),
      });

      const data = await response.json();
      console.log('Job seeker record response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create job seeker record');
      }

      return { success: true, data };
    } catch (error) {
      console.error("Error creating job seeker record:", error);
      throw error;
    }
  };

  const handleRegistration = async (e) => {
    e.preventDefault();

    // Basic validation - only first_name is required, email is optional
    if (!formData.first_name.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please enter candidate first name',
        confirmButtonColor: '#f27474'
      });
      return;
    }

    // Email format validation (only if email is provided)
    if (formData.email.trim()) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email.trim())) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid Email',
          text: 'Please enter a valid email address or leave it empty',
          confirmButtonColor: '#f27474'
        });
        return;
      }
    }

    if (!agencyUserId) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Agency information is missing. Please try again.',
        confirmButtonColor: '#d33'
      });
      return;
    }

    // Prepare payload for agency registration (no OTP verification)
    const userPayload = {
      first_name: formData.first_name.trim(),
      last_name: formData.last_name.trim() || formData.first_name.trim(),
      email: formData.email.trim() || null, // Send null if empty
      mobile_number: formData.mobile_number || null,
      whatsapp_number: formData.whatsapp_number || null,
      mobile_number_country_code: formData.mobile_number_country_code,
      password: "Jobseeker@123",
      role: "job seeker",
      source: "agency",
      agency_uid: agencyUserId,
      agency_email: agencyUserEmail || ""
    };

    console.log('Registering job seeker via agency:', userPayload);
    console.log('API URL:', `${BaseUrl}/agency-user-register`);

    try {
      setLoading(true);

      // Step 1: Register user in users table
      const userResponse = await fetch(`${BaseUrl}/agency-user-register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userPayload),
      });

      const userData = await userResponse.json();
      console.log('User registration response data:', userData);

      if (!userResponse.ok) {
        let errorMessage = 'Registration failed. ';
        if (userData && userData.message) {
          errorMessage = userData.message;
        } else if (userData && userData.error) {
          errorMessage += userData.error;
        } else {
          errorMessage += 'Please check all fields and try again.';
        }

        Swal.fire({
          icon: 'error',
          title: 'Registration Failed',
          text: errorMessage,
          confirmButtonColor: '#d33'
        });
        return;
      }

      // Extract the AUTO-INCREMENTED ID
      const userId = userData.user_id || userData.id || userData.data?.user_id || userData.data?.id;

      if (!userId) {
        console.error('No user ID received in response:', userData);
        throw new Error('User registration succeeded but no user ID was returned');
      }

      // Step 2: Create job seeker record in job_seekers table
      try {
        await createJobSeekerRecord(userId);
        
        // Track usage
        try {
          await axios.post(`${BaseUrl}/api/agency/track-usage`, {
            agencyId: agencyUserId,
            action: 'candidate_posting'
          });
        } catch (usageError) {
          console.error('Usage tracking failed:', usageError);
        }

        Swal.fire({
          icon: 'success',
          title: 'Registration Successful!',
          text: `Job Seeker "${formData.first_name}" has been created successfully.`,
          confirmButtonColor: '#28a745'
        }).then(() => {
          // Reset form
          setFormData({
            first_name: "",
            last_name: "",
            email: "",
            mobile_number: "",
            mobile_number_country_code: "+91",
            whatsapp_number: "",
            whatsapp_country_code: "+91",
          });

          if (onSuccess) onSuccess();
          navigate("/addjobseeker");
        });

      } catch (jobSeekerError) {
        console.error('❌ Failed to create job seeker record:', jobSeekerError);
        Swal.fire({
          icon: 'warning',
          title: 'Partial Success',
          text: `User was created but details could not be saved.`,
          confirmButtonColor: '#ffc107'
        }).then(() => {
          if (onSuccess) onSuccess();
          navigate("/addjobseeker");
        });
      }

    } catch (error) {
      console.error("Error in registration process:", error);
      Swal.fire({
        icon: 'error',
        title: 'Registration Failed',
        text: error.message || 'Please check your connection and try again.',
        confirmButtonColor: '#d33'
      });
    } finally {
      setLoading(false);
    }
  };

  const renderForm = () => (
    <>
      <div className="mb-3">
        <input
          type="text"
          name="first_name"
          className="form-control rounded-input"
          placeholder="Enter candidate first name"
          value={formData.first_name}
          onChange={handleChange}
          required
        />
      </div>

      <div className="mb-3">
        <input
          type="text"
          name="last_name"
          className="form-control rounded-input"
          placeholder="Enter candidate last name"
          value={formData.last_name}
          onChange={handleChange}
        />
      </div>

      <div className="mb-3">
        <input
          type="email"
          name="email"
          className={`form-control rounded-input ${emailError ? 'is-invalid' : ''}`}
          placeholder="Enter candidate email (Optional)"
          value={formData.email}
          onChange={handleChange}
        />
        {emailError && (
          <div className="invalid-feedback d-block">{emailError}</div>
        )}
      </div>

      {/* Mobile Number with Country Code */}
      <div className="mb-3">
        <label className="form-label small fw-semibold">Mobile Number</label>
        <PhoneInputWithCountryCode
          numberField="mobile_number"
          countryCodeField="mobile_number_country_code"
          placeholder="Enter mobile number"
          formData={formData}
          onCountryCodeChange={handleCountryCodeChange}
          onInputChange={handleChange}
          userType={userType}
        />
      </div>

      {/* WhatsApp Number with Country Code */}
      <div className="mb-4">
        <label className="form-label small fw-semibold">WhatsApp Number (Optional)</label>
        <PhoneInputWithCountryCode
          numberField="whatsapp_number"
          countryCodeField="whatsapp_country_code"
          placeholder="Enter WhatsApp number (optional)"
          formData={formData}
          onCountryCodeChange={handleCountryCodeChange}
          onInputChange={handleChange}
          userType={userType}
        />
      </div>
    </>
  );

  const getSubmitButtonText = () => {
    if (loading) return "Processing...";
    return "Submit";
  };

  return (
    <>
      <AgencyNavbar />
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="card-jobseekeerreg-agency shadow-sm" style={{ width: "100%", maxWidth: "600px", marginTop: '70px' }}>
          <div className="card-body p-4">
            <div className="text-center mb-4">
              <h4 className="card-title">Job Seeker Registration</h4>
            </div>

            <div className="bg-primary text-white rounded d-flex justify-content-center mb-4 py-2">
              <div className="d-flex flex-column align-items-center" style={{ fontSize: "13px" }}>
                <div className="d-flex align-items-center">
                  <div className="custom-radio-icon me-2 selected">
                    <FaCheck size={10} color="#fff" />
                  </div>
                  <span className="fw-semibold">Job Seeker</span>
                </div>
                <div className="text-white-50" style={{ fontSize: "11px" }}>
                  Looking for a job
                </div>
              </div>
            </div>

            <form onSubmit={handleRegistration}>
              {renderForm()}

              <button
                type="submit"
                className="btn btn-primary w-100 d-flex justify-content-center align-items-center rounded-pill py-2 mb-3"
                disabled={loading}
              >
                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                  <span style={{ fontSize: "17px" }}>
                    {getSubmitButtonText()}
                  </span>
                  {!loading && (
                    <FaChevronRight size={18} />
                  )}
                </div>
              </button>

              <div className="text-center">
                <small className="text-muted">
                  Candidate email & phone number are private and visible only to Agency.
                </small>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobSeekerRegistration;
